import fetchClient, { ApiResponse } from '../api-client'
import { PickupOrder } from '../pickup-orders/types/PickupOrder'
import { UploadUserPkgReceiptPayload } from './types/UploadUserPkgReceiptPayload'
import { UserPkg } from './types/UserPkg'

export const getUserPkgs = async () => {
  const res = await fetchClient.get<ApiResponse<UserPkg[]>>('/user-pkg')
  return res.data.data
}
export const getUserPickupOrders = async () => {
  const res = await fetchClient.get<ApiResponse<PickupOrder[]>>('/user-pickup-orders')
  return res.data.data
}
export const uploadUserPkgReceipt = async ({ file, packageId, price }: UploadUserPkgReceiptPayload): Promise<UserPkg> => {
  try {
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    const formData = new FormData()
    if (file) {
      if (!allowedFileTypes.includes(file.type)) {
        throw new Error(`file type not allowed: ${file.type}`)
      }
      formData.append('file', file)
    }
    if (price) {
      formData.append('price', price.toString())
    }

    formData.append('packageId', packageId)

    const res = await fetchClient.post(`/user-pkg/uploadReceipt`, formData)
    // console.log("uploadFile - res:", res)

    return res.data.data
  } catch (error) {
    console.log('uploadFile - error:', error)
    throw error
  }
}
